import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Loader2 } from "lucide-react";
import { publicApi, setToken } from "@/lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  // admin@james40.local
  // HushHush40!

  async function login() {
    if (loading) return;
    const em = email.trim();
    const pw = password;
    if (!em || !pw) {
      toast.error("Add your email and password.");
      return;
    }
    setLoading(true);
    try {
      const res = await publicApi.post("/auth/login", { email: em, password: pw });
      const data = res.data;
      if (!data?.token) {
        toast.error("Login response missing token.");
        return;
      }
      setToken(data.token);
      toast.success("Welcome to the vault.");
      nav("/admin");
    } catch (err) {
      const status = err.response?.status;
      if (status === 401) {
        toast.error("Wrong credentials.");
      } else if (status) {
        toast.error(`Login failed (${status}).`);
      } else {
        toast.error("Network error. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  }

  function onKeyDown(e) {
    if (e.key === "Enter") { e.preventDefault(); login(); }
  }

  return (
    <div className="min-h-screen bg-cream text-ink flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="max-w-md w-full">
        <div className="text-xs tracking-[0.4em] text-ink/60 mb-3">— PRIVATE —</div>
        <h1 className="hush-title text-5xl md:text-6xl mb-8">The Vault.</h1>
        <div className="space-y-6 bg-white/70 border border-ink/15 rounded-3xl p-8">
          <div>
            <label className="text-xs tracking-[0.3em] text-ink/60 block mb-2">EMAIL</label>
            <input
              type="email"
              className="field-underline text-xl"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={onKeyDown}
              data-testid="admin-email"
              autoComplete="email"
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck={false}
            />
          </div>
          <div>
            <label className="text-xs tracking-[0.3em] text-ink/60 block mb-2">PASSWORD</label>
            <input
              type="password"
              className="field-underline text-xl"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={onKeyDown}
              data-testid="admin-password"
              autoComplete="current-password"
            />
          </div>
          <button
            type="button"
            onClick={login}
            disabled={loading}
            className="w-full inline-flex items-center justify-center gap-3 bg-ink text-cream rounded-full px-8 py-4 text-lg hover:bg-ink/90 disabled:opacity-70 active:scale-[0.98] transition"
            data-testid="admin-login-btn"
          >
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Lock className="w-5 h-5" />}
            Enter the vault
          </button>
        </div>
        <p className="mt-6 text-sm text-ink/60 font-hand text-lg">
          Wrong door? This isn't for James.
        </p>
      </div>
    </div>
  );
}
